module.exports = __webpack_public_path__ + "8ea601327f6e4f4fcaf10d0a57c65765.png";